import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private httpClient: HttpClient
  ) { }

  upload(request: any) {
    return this.httpClient.post<any>(
      `${environment.storage}/o?uploadType=media&name=${request.name}`,
      request.file,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  request.type,
        })
      }
    );
  }
}
